module.exports = __webpack_public_path__ + "static/media/round-timer-01.6b6c0749.svg";